import React from 'react';
import { object, string } from 'yup';
import {
  Formik,
  Form,
} from 'formik';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormHttpSaveBtn from '~/commons/components/FormHttpSaveBtn.jsx';

const schema = object({
  schoolName: string().required('必填'),
  name: string().required('必填'),
  phone: string().required('必填'),
  email: string().email('必須為有效電郵地址').required('必填'),
});
const defaults = {
  schoolName: '',
  name: '',
  phone: '',
  email: '',
};

const FormRegister = ({ res, onSubmit }) => (
  <Formik
    validationSchema={schema}
    initialValues={defaults}
    validateOnMount={true}
    onSubmit={(values) => onSubmit(values)}
  >
   <Form>
      <FormHttpAlert res={res} />
      <div className="mb-3">
        *為必填資料
      </div>
      <FormGroup
        name="schoolName"
        label="學校名稱*"
      />
      <FormGroup
        name="name"
        label="老師姓名*"
      />
      <FormGroup
        name="phone"
        label="聯絡電話*"
      />
      <FormGroup
        name="email"
        label="聯絡電郵*"
      />

      <div className="form-group text-right">
        <FormHttpSaveBtn
          res={res}
          type="submit"
          className="btn-secondary btn-block"
          icon={faPaperPlane}
        >
          提交申請
        </FormHttpSaveBtn>
      </div>
    </Form>
  </Formik>
);

export default FormRegister;
